import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Shield, Clock, MapPin } from 'lucide-react';

const ApexCTA = () => {
  const navigate = useNavigate();

  const goToApplication = () => {
    navigate('/5k-guarantee#application');
  };

  const benefits = [
    { id: 'cta-benefit-1', icon: Shield, text: 'No obligation, completely free' },
    { id: 'cta-benefit-2', icon: Clock, text: '30-minute consultation' },
    { id: 'cta-benefit-3', icon: MapPin, text: 'Check area availability' }
  ];

  return (
    <section className="relative py-20 md:py-28 bg-[#0A0A0A] overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0d1f12]/50 via-[#0A0A0A] to-[#0A0A0A]" />
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#22C55E]/10 rounded-full blur-[150px]" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#22C55E]/5 rounded-full blur-[120px]" />
      
      <div className="relative max-w-4xl mx-auto px-6 md:px-12 lg:px-24 text-center">
        {/* Exclusivity badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#22C55E]/30 bg-[#22C55E]/10 mb-8">
          <MapPin className="w-4 h-4 text-[#22C55E]" />
          <span className="text-[#22C55E] text-sm font-medium">
            Only 1 Partner Per Local Area
          </span>
        </div>

        {/* Main headline */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
          Ready to Stop Leaving Money
          <br />
          <span className="text-[#22C55E]">on the Table?</span>
        </h2>

        {/* Description */}
        <p className="text-lg md:text-xl text-[#A1A1AA] max-w-2xl mx-auto mb-8">
          Book your free discovery audit today. We will analyse your current sales process 
          and show you exactly where you can improve — with no obligation.
        </p>

        {/* Benefits */}
        <div className="flex flex-wrap justify-center gap-6 mb-10">
          {benefits.map((benefit) => (
            <div key={benefit.id} data-testid={benefit.id} className="flex items-center gap-2">
              <benefit.icon className="w-5 h-5 text-[#22C55E]" />
              <span className="text-white text-sm">{benefit.text}</span>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <button
          onClick={goToApplication}
          data-testid="cta-discovery-audit"
          className="group inline-flex items-center justify-center gap-3 bg-[#22C55E] hover:bg-[#16A34A] text-black font-bold uppercase tracking-wide rounded-full px-10 py-5 text-lg transition-all duration-300 hover:-translate-y-1 shadow-lg shadow-[#22C55E]/25 hover:shadow-[#22C55E]/40"
        >
          Book Your Free Discovery Audit
          <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
        </button>

        {/* Subtext */}
        <p className="text-center text-[#71717A] text-sm">
          Spaces are limited. We only partner with one gym per local area to avoid conflicts of interest.
        </p>
      </div>
    </section>
  );
};

export default ApexCTA;
